import FAQs from '../../constants/FAQs';
import Dropdown from './components/Dropdown';
import styles from './styles.module.scss';

const FAQ = () => (
  <div className={styles.faqContainer} id="faq">
    <div className={styles.title}>Frequently Asked Questions</div>
    <div className={styles.faqSection}>
      {FAQs.map((faq) => (
        <Dropdown question={faq.question} answer={faq.answer} key={faq.question} />
      ))}
    </div>
  </div>
);

export default FAQ;
